
import { AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { GuestListItem } from "./GuestListItem";

interface GuestInfo {
  invite_id: string;
  display_name: string;
  phone_number?: string;
  rsvp_status: 'invited' | 'accepted' | 'declined' | 'maybe';
  feedback_text?: string | null;
  suggested_venue?: string | null;
  suggested_time?: string | null;
  claimed_by_user_id?: string | null;
  user_phone_number?: string | null;
  selected_dates?: string[] | null;
  selected_times?: string[] | null;
  avatar_url?: string | null;
  user_full_name?: string | null;
  guest_avatar_url?: string | null;
}

interface GuestGroupProps {
  title: string;
  icon: React.ReactElement;
  guests: GuestInfo[];
  status: 'invited' | 'accepted' | 'declined' | 'maybe';
  isHost: boolean;
  onViewFeedback: (guest: GuestInfo) => void;
  onRemoveGuest?: (guest: GuestInfo) => void;
}

export const GuestGroup = ({
  title,
  icon,
  guests,
  status,
  isHost,
  onViewFeedback,
  onRemoveGuest
}: GuestGroupProps) => {
  if (guests.length === 0) return null;
  
  return (
    <AccordionItem value={title.toLowerCase().replace(/\s/g, '-')}>
      <AccordionTrigger className="px-4 py-2">
        <div className="flex items-center gap-2">
          {icon}
          <span className="text-sm font-extralight">{title} ({guests.length})</span>
        </div>
      </AccordionTrigger>
      <AccordionContent>
        <div className="space-y-2">
          {guests.map(guest => {
            // Determine if the guest has provided any feedback
            const hasFeedback = !!(
              guest.feedback_text || 
              guest.suggested_venue || 
              guest.suggested_time || 
              (guest.selected_dates && guest.selected_dates.length > 0)
            );
            
            return (
              <GuestListItem 
                key={guest.invite_id} 
                guest={guest} 
                isHost={isHost} 
                onViewFeedback={() => onViewFeedback(guest)} 
                onRemoveGuest={onRemoveGuest ? () => onRemoveGuest(guest) : undefined} 
                hasFeedback={hasFeedback}
              />
            );
          })}
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};
